__turbopack_context__.v({
  "file": "uUZQLW_file",
  "file-drop": "uUZQLW_file-drop",
  "pill-row-1": "uUZQLW_pill-row-1",
  "pill-row-2": "uUZQLW_pill-row-2",
  "pill-row-3": "uUZQLW_pill-row-3",
  "pill-row-4": "uUZQLW_pill-row-4",
  "pillRow1": "uUZQLW_pillRow1",
  "pillRow2": "uUZQLW_pillRow2",
  "pillRow3": "uUZQLW_pillRow3",
  "pillRow4": "uUZQLW_pillRow4",
});
